/**
* @render react
* @name Date
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { withPolaris } from 'Components/protons/Polaris';

// Sets DayJS to use timezones.
dayjs.extend(utc);

/**
 * Date component
 *
 * @param {Object} props - the props object
 * @param {string} props.date - Date you want to format
 * @param {string} props.format - Date you want to format
 * @param {Object} props.context - Extra information coming from Polaris provider.
 * @param {Object} props.extraClassNames - Extra class names to be applied to the component
 * @param {boolean} props.loadStyles - Whether to apply the class names for styling
 *
 */
const Date = (
  {
    date,
    format,
    loadStyles,
    extraClassNames,
    context: { cssPrefix, dateFormat },
  },
) => (
  <span
    className={classNames({
      [`${cssPrefix}__date`]: loadStyles,
      ...extraClassNames,
    })}
  >
    {dayjs(date).format(format || dateFormat)}
  </span>
);

/**
 * Valid props
 */
Date.propTypes = {
  date: PropTypes.string,
  format: PropTypes.string,
  loadStyles: PropTypes.bool,
  context: PropTypes.shape(),
  extraClassNames: PropTypes.shape(),
};

/**
 * Default props
 */
Date.defaultProps = {
  date: '',
  format: '',
  loadStyles: true,
  context: {},
  extraClassNames: {},
};

export default withPolaris(Date);
